// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"60c7a516","885":"59e38f97"}[chunkId] + ".chunk.js";
};